{
	"frames": {
		"idle_0": {
			"frame": {
				"x": 49,
				"y": 65,
				"w": 174,
				"h": 180
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 136,
				"y": 155,
				"w": 174,
				"h": 180
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 200
		},
		"idle_1": {
			"frame": {
				"x": 224,
				"y": 62,
				"w": 213,
				"h": 182
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 93,
				"y": 153,
				"w": 213,
				"h": 182
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 200
		},
		"idle_2": {
			"frame": {
				"x": 451,
				"y": 62,
				"w": 197,
				"h": 181
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 97,
				"y": 153,
				"w": 197,
				"h": 181
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 200
		},
		"idle_3": {
			"frame": {
				"x": 691,
				"y": 62,
				"w": 165,
				"h": 183
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 115,
				"y": 153,
				"w": 165,
				"h": 183
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 200
		},
		"idle_4": {
			"frame": {
				"x": 912,
				"y": 62,
				"w": 195,
				"h": 183
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 114,
				"y": 152,
				"w": 195,
				"h": 183
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 200
		},
		"walk_0": {
			"frame": {
				"x": 0,
				"y": 245,
				"w": 219,
				"h": 265
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 99,
				"y": 126,
				"w": 219,
				"h": 265
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 120
		},
		"walk_1": {
			"frame": {
				"x": 220,
				"y": 254,
				"w": 228,
				"h": 255
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 99,
				"y": 134,
				"w": 228,
				"h": 255
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 190
		},
		"walk_2": {
			"frame": {
				"x": 461,
				"y": 257,
				"w": 214,
				"h": 242
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 103,
				"y": 139,
				"w": 214,
				"h": 242
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 190
		},
		"walk_3": {
			"frame": {
				"x": 675,
				"y": 245,
				"w": 224,
				"h": 265
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 100,
				"y": 126,
				"w": 224,
				"h": 265
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 190
		},
		"sleep_0": {
			"frame": {
				"x": 20,
				"y": 510,
				"w": 203,
				"h": 125
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 113,
				"y": 200,
				"w": 203,
				"h": 125
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 300
		},
		"sleep_1": {
			"frame": {
				"x": 256,
				"y": 518,
				"w": 187,
				"h": 124
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 119,
				"y": 207,
				"w": 187,
				"h": 124
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 300
		},
		"sleep_2": {
			"frame": {
				"x": 461,
				"y": 526,
				"w": 201,
				"h": 112
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 98,
				"y": 215,
				"w": 201,
				"h": 112
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 300
		},
		"sleep_3": {
			"frame": {
				"x": 715,
				"y": 510,
				"w": 159,
				"h": 131
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 128,
				"y": 199,
				"w": 159,
				"h": 131
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 300
		},
		"scratch_0": {
			"frame": {
				"x": 27,
				"y": 656,
				"w": 203,
				"h": 201
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 113,
				"y": 123,
				"w": 203,
				"h": 201
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"scratch_1": {
			"frame": {
				"x": 230,
				"y": 643,
				"w": 202,
				"h": 214
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 90,
				"y": 110,
				"w": 202,
				"h": 214
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"scratch_2": {
			"frame": {
				"x": 461,
				"y": 654,
				"w": 210,
				"h": 203
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 89,
				"y": 121,
				"w": 210,
				"h": 203
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"scratch_3": {
			"frame": {
				"x": 710,
				"y": 648,
				"w": 204,
				"h": 209
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 116,
				"y": 119,
				"w": 204,
				"h": 209
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"scratch_4": {
			"frame": {
				"x": 915,
				"y": 642,
				"w": 215,
				"h": 211
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 105,
				"y": 113,
				"w": 215,
				"h": 211
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"scratch_5": {
			"frame": {
				"x": 1165,
				"y": 654,
				"w": 174,
				"h": 199
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 132,
				"y": 125,
				"w": 174,
				"h": 199
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 100
		},
		"entry_0": {
			"frame": {
				"x": 0,
				"y": 860,
				"w": 300,
				"h": 300
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 49,
				"y": 43,
				"w": 300,
				"h": 300
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 150
		},
		"entry_1": {
			"frame": {
				"x": 300,
				"y": 860,
				"w": 290,
				"h": 300
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 79,
				"y": 45,
				"w": 290,
				"h": 300
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 150
		},
		"entry_2": {
			"frame": {
				"x": 590,
				"y": 861,
				"w": 315,
				"h": 297
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 66,
				"y": 46,
				"w": 315,
				"h": 297
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 150
		},
		"entry_3": {
			"frame": {
				"x": 905,
				"y": 860,
				"w": 283,
				"h": 284
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 74,
				"y": 44,
				"w": 283,
				"h": 284
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 150
		},
		"landing_0": {
			"frame": {
				"x": 0,
				"y": 1160,
				"w": 320,
				"h": 259
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 46,
				"y": 79,
				"w": 320,
				"h": 259
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 90
		},
		"landing_1": {
			"frame": {
				"x": 320,
				"y": 1160,
				"w": 290,
				"h": 260
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 64,
				"y": 79,
				"w": 290,
				"h": 260
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 90
		},
		"landing_2": {
			"frame": {
				"x": 610,
				"y": 1161,
				"w": 278,
				"h": 259
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 60,
				"y": 80,
				"w": 278,
				"h": 259
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 90
		},
		"landing_3": {
			"frame": {
				"x": 919,
				"y": 1195,
				"w": 283,
				"h": 217
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 71,
				"y": 110,
				"w": 283,
				"h": 217
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 90
		},
		"landing_fast_0": {
			"frame": {
				"x": 0,
				"y": 1420,
				"w": 290,
				"h": 243
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 71,
				"y": 116,
				"w": 290,
				"h": 243
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 35
		},
		"landing_fast_1": {
			"frame": {
				"x": 291,
				"y": 1420,
				"w": 299,
				"h": 224
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 64,
				"y": 113,
				"w": 299,
				"h": 224
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 35
		},
		"landing_fast_2": {
			"frame": {
				"x": 590,
				"y": 1420,
				"w": 267,
				"h": 243
			},
			"rotated": false,
			"trimmed": true,
			"spriteSourceSize": {
				"x": 68,
				"y": 113,
				"w": 267,
				"h": 243
			},
			"sourceSize": {
				"w": 416,
				"h": 416
			},
			"duration": 35
		}
	},
	"animations": {
		"idle": {
			"frames": ["idle_0", "idle_1", "idle_2", "idle_3", "idle_4"],
			"frameDurationMs": 200,
			"loop": true,
			"flipX": false
		},
		"walk_right": {
			"frames": ["walk_0", "walk_1", "walk_2", "walk_3"],
			"frameDurationMs": 120,
			"loop": true,
			"flipX": false,
			"facing": "right"
		},
		"walk_left": {
			"frames": ["walk_0", "walk_1", "walk_2", "walk_3"],
			"frameDurationMs": 120,
			"loop": true,
			"flipX": true,
			"facing": "left"
		},
		"sleep": {
			"frames": ["sleep_0", "sleep_1", "sleep_2", "sleep_3"],
			"frameDurationMs": 300,
			"loop": true,
			"flipX": false
		},
		"scratch": {
			"frames": [
				"scratch_0",
				"scratch_1",
				"scratch_2",
				"scratch_3",
				"scratch_4",
				"scratch_5"
			],
			"frameDurationMs": 100,
			"loop": false,
			"flipX": false
		},
		"entry": {
			"frames": ["entry_0", "entry_1", "entry_2", "entry_3"],
			"frameDurationMs": 150,
			"loop": false,
			"flipX": false,
			"facing": "left"
		},
		"landing": {
			"frames": ["landing_0", "landing_1", "landing_2", "landing_3"],
			"frameDurationMs": 90,
			"loop": false,
			"flipX": false,
			"facing": "left"
		},
		"landing_fast": {
			"frames": ["landing_fast_0", "landing_fast_1", "landing_fast_2"],
			"frameDurationMs": 35,
			"loop": false,
			"flipX": false,
			"facing": "left"
		}
	},
	"meta": {
		"image": "jolie_spritesheet.png",
		"size": {
			"w": 1339,
			"h": 1663
		},
		"scale": "1",
		"frameTags": [
			{
				"from": 0,
				"to": 4,
				"name": "idle",
				"direction": "forward"
			},
			{
				"from": 5,
				"to": 8,
				"name": "walk",
				"direction": "forward"
			},
			{
				"from": 9,
				"to": 12,
				"name": "sleep",
				"direction": "forward"
			},
			{
				"from": 13,
				"to": 18,
				"name": "scratch",
				"direction": "forward"
			},
			{
				"name": "entry",
				"from": 19,
				"to": 22,
				"direction": "forward"
			},
			{
				"name": "landing",
				"from": 23,
				"to": 26,
				"direction": "forward"
			},
			{
				"name": "landing_fast",
				"from": 27,
				"to": 29,
				"direction": "forward"
			}
		],
		"anchor": {
			"y": 0.7692307692307693,
			"x": 0.5
		},
		"coordinateSystem": "top-left",
		"timing": "Suggested defaults; durations are in milliseconds."
	}
}
